module.exports = __webpack_public_path__ + "static/11-df0756e74098151181266a8057242d08.jpg";